import { render, staticRenderFns } from "./OcorrenciasInserir.vue?vue&type=template&id=cb21de4e"
import script from "./OcorrenciasInserir.vue?vue&type=script&lang=js"
export * from "./OcorrenciasInserir.vue?vue&type=script&lang=js"
import style0 from "./OcorrenciasInserir.vue?vue&type=style&index=0&id=cb21de4e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports